import { connect } from 'react-redux'
import { doHideTicketPreviewModal } from 'actions/modals'
import { doToggleStarred } from 'actions/tickets'
import {
  makeSelectRawTicketById,
  makeSelectTicketFlags,
} from 'selectors/tickets'
import { makeIsTicketPreviewOpen, selectModalOffset } from 'selectors/modals'

import {
  makeSelectCommentsByTicketId,
  makeSelectIsLoadingByTicketId,
} from '../../selectors/comments'
import { doFetchTicketComments } from '../../operations'

import TicketPreviewView from './view'

const select = () => {
  const selectTicketById = makeSelectRawTicketById()
  const selectTicketFlags = makeSelectTicketFlags()
  const selectIsModalOpen = makeIsTicketPreviewOpen()
  const selectCommentsByTicketId = makeSelectCommentsByTicketId()
  const selectIsLoadingByTicketId = makeSelectIsLoadingByTicketId()
  return (state, props) => {
    return {
      comments: selectCommentsByTicketId(state, props),
      flags: selectTicketFlags(state, props),
      isModalOpen: selectIsModalOpen(state, props),
      ticket: selectTicketById(state, props),
      modalOffset: selectModalOffset(state),
      isLoading: selectIsLoadingByTicketId(state, props),
    }
  }
}

const perform = {
  hideTicketPreviewModal: doHideTicketPreviewModal,
  fetchTicketComments: doFetchTicketComments,
  toggleStarred: doToggleStarred,
}

export default connect(select, perform)(TicketPreviewView)
